module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg bg-image-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.isWjmm == false) ? _c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('button', {
      key: index,
      class: index === _vm.navListIndex ? 'nav-item' : 'nav-item1',
      on: {
        "click": function($event) {
          return _vm.handlenav(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.navListIndex == 0 && _vm.isWjmm == false) ? _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && _vm.isWjmm == true) ? _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.newPassword),
      expression: "form.newPassword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "newPassword", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1 || _vm.isWjmm) ? _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && _vm.isWjmm == false) ? _c('button', {
    staticClass: "xzbtn",
    on: {
      "click": _vm.handlewangjimima
    }
  }, [_vm._v("忘记密码")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1 && _vm.countdown == false || _vm.isWjmm && _vm.countdown == false) ? _c('button', {
    staticClass: "xzbtn",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1 && _vm.countdown || _vm.isWjmm && _vm.countdown) ? _c('button', {
    staticClass: "xzbtn"
  }, [_vm._v(_vm._s(_vm.timeText) + "秒")]) : _vm._e(), _vm._v(" "), (_vm.isWjmm == false) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (_vm.isWjmm) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.update_password
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), (_vm.isWjmm) ? _c('button', {
    staticClass: "xzbtn1",
    on: {
      "click": _vm.handlefanhui
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (_vm.isWjmm == false) ? _c('div', {
    staticClass: "xieyi"
  }, [_c('span', {
    staticClass: "xieyi-span",
    on: {
      "click": function($event) {
        return _vm.handlexieyi(0)
      }
    }
  }, [_vm._v("《Home用户协议》")]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span1"
  }, [_vm._v("和")]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span",
    on: {
      "click": function($event) {
        return _vm.handlexieyi(1)
      }
    }
  }, [_vm._v("《Home隐私协议》")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "left-span"
  }, [_vm._v("Hi 你好！")]), _vm._v(" "), _c('span', {
    staticClass: "left-span1"
  }, [_vm._v("欢迎进入公会管理系统")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-373546e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ghdenglu.vue
// module id = 618
// module chunks = 1